<template>
  <Text
    size="3xl"
    weight="bold"
    :data-test-id="productDetailsTestId('pricePerUnit')"
    data-fs="pricePerUnit"
    class="nowrap text-charcoal-default"
    :class="clearanceTextClass"
  >
    {{
      toCurrency({
        value: price,
      })
    }}
  </Text>
  <Text size="caption" weight="bold" class="nowrap text-charcoal-default" :class="clearanceTextClass">
    {{ productUnit }}
  </Text>
  <Text size="caption" class="nowrap" :data-test-id="productDetailsTestId('vat')" data-fs="vat">
    {{ VatLabel }}
  </Text>
</template>

<script lang="ts" setup>
import { toCurrency } from "mkm-avengers";

const { isVatIncluded } = useUIState();

const props = defineProps<{
  unit: string;
  price: number;
  clearance: boolean;
  productDetailsViewMobile?: boolean;
}>();

const productDetailsTestId = (id: string) => (props.productDetailsViewMobile ? `mobile-${id}` : id);

const productUnit = computed(() => productUnitTranslation(`${props.unit}` as ProductDetailsType));

const VatLabel = computed(() => (isVatIncluded.value ? "inc. VAT" : "ex. VAT"));

const clearanceTextClass = computed(() => ({
  "ui-text-crimson-default": props.clearance === true,
}));
</script>
